import { CalendarClockIcon, HeartPulseIcon, RepeatIcon, LayoutListIcon } from 'lucide-react'
import type { LucideIcon } from 'lucide-react'

export const painPoints: { icon: LucideIcon; text: string }[] = [
  {
    icon: CalendarClockIcon,
    text: "Le dimanche soir, vous ne savez toujours pas exactement ce que vous allez enseigner lundi.",
  },
  {
    icon: HeartPulseIcon,
    text: "Un élève vous parle d'une douleur, d'une opération récente ou d'une grossesse, et vous improvisez une adaptation sur le moment, sans repère écrit.",
  },
  {
    icon: RepeatIcon,
    text: "Vous répétez les mêmes exercices de base d'un trimestre à l'autre, faute d'avoir une progression organisée sous la main.",
  },
  {
    icon: LayoutListIcon,
    text: "Vous n'avez aucun calendrier annuel pour répartir vos six niveaux sur une année complète d'enseignement.",
  },
]
